import { PowerResourceType } from '@/contract/map.base'
import { FilterItem } from '@/pages/chargermap/components/filter/filter.model'
import { FilterState, PowerResource } from '@/pages/chargermap/contract/map'
import { EnergyStationModel } from '@/pages/chargermap/models/plan.model'

/**
 * 获取加电资源类型
 * @param {PowerResource} type 加电资源
 * @returns {PowerResourceType} 加电资源类型
 */
export const getPowerResourceTypeVgl = (type: string | undefined) => {
  switch (type) {
    case 'PowerSwap':
      return PowerResourceType.PowerSwap
    case 'NioChargeStationNpc':
      return PowerResourceType.NioChargeStationNpc
    case 'NioChargeStationDest':
      return PowerResourceType.NioChargeStationDest
    default:
      return PowerResourceType.PowerSwap
  }
}

/**
 * 获取加电资源类型
 * @param {PowerResource} resource 加电资源
 * @returns {PowerResourceType} 加电资源类型
 */
export const getPowerResourceType = (resource: PowerResource | EnergyStationModel) => {
  if (resource.type === 'PowerSwap') {
    return PowerResourceType.PowerSwap
  }

  if (resource.type === 'Merged') {
    return PowerResourceType.Merged
  }

  if (resource.type === 'ChargeStation') {
    switch (resource.chargeStationType) {
      case 'NioChargeStationNpc':
        return PowerResourceType.NioChargeStationNpc
      case 'NioChargeStationDest':
        return PowerResourceType.NioChargeStationDest
      case 'ThirdChargeStation':
        return PowerResourceType.ThirdChargeStation
    }
  }

  return PowerResourceType.Unknown
}

/**
 * 通过pointType和pointSubType两个字段判断资源类型
 * @param {PowerResource} resource 加电资源
 * @returns {PowerResourceType} 加电资源类型
 */
export const getPowerResourceTypeV2 = (resource: any) => {
  if (resource.pointType === 'recharge') {
    // 充换电资源
    switch (resource.pointSubType) {
      case 'PowerSwap':
        return PowerResourceType.PowerSwap
      case 'NioChargeStationNpc':
        return PowerResourceType.NioChargeStationNpc
      case 'NioChargeStationDest':
        return PowerResourceType.NioChargeStationDest
      case 'ThirdChargeStation':
        return PowerResourceType.ThirdChargeStation
      default:
        break
    }
  }
  // 20240523 兼容处理
  if (resource.pointType === 'recharge|ps') {
    // 换电资源
    switch (resource.pointSubType) {
      case 'PowerSwap':
        return PowerResourceType.PowerSwap
      default:
        break
    }
  }
  if (resource.pointType === 'recharge|cs') {
    // 充电资源
    switch (resource.pointSubType) {
      case 'NioChargeStationNpc':
        return PowerResourceType.NioChargeStationNpc
      case 'NioChargeStationDest':
        return PowerResourceType.NioChargeStationDest
      case 'ThirdChargeStation':
        return PowerResourceType.ThirdChargeStation
      default:
        break
    }
  }
  if (resource.pointType === 'nio_store') {
    // 蔚来门店资源
    switch (resource.pointSubType) {
      case 'nio_store':
        // 兼容fy nio_store->nio_space组合
        return PowerResourceType.NioSpace
      case 'nio_space':
        return PowerResourceType.NioSpace
      case 'nio_house':
        return PowerResourceType.NioHouse
      case 'nio_road_show':
        return PowerResourceType.NioRoadShow
      default:
        break
    }
  }
  if (resource.pointType === 'test_drive') {
    // 蔚来门店资源
    switch (resource.pointSubType) {
      case 'test_drive':
        return PowerResourceType.TestDrive
      default:
        break
    }
  }
  if (resource.pointType === 'service_center') {
    // 蔚来门店资源
    switch (resource.pointSubType) {
      case 'service_center':
        return PowerResourceType.ServiceCenter
      default:
        break
    }
  }

  return PowerResourceType.Unknown
}

/**
 * 判断是否显示全部类型的加电资源
 * @param {string} filter 加电资源筛选器
 * @returns {boolean} 是否显示全部类型的加电资源
 */
export const showAllResourceTypes = (filter: FilterItem[]) => {
  return (
    filter.every((item) => item.filterState === FilterState.On) ||
    filter.every((item) => item.filterState === FilterState.Off)
  )
}

// /**
//  * 判断是否显示三方桩
//  * @param {string} filter 加电资源筛选器
//  * @returns {boolean} 是否显示三方桩
//  */
// export const showThirdResourceTypes = (filter: FilterItem[]) => {
//   const third = filter.find((item) => item.key === 'third_station')
//   return showAllResourceTypes(filter) || third?.filterState === FilterState.On
// }

// /**
//  * 改变加电资源筛选条件
//  * @param {PowerResourceFilter} filter 加电资源筛选器
//  * @param {PowerResourceType} type 加电资源类型
//  * @returns {boolean} 是否显示三方桩
//  */
// export const changeFilterByResourceType = (
//   filter: PowerResourceFilter,
//   type: PowerResourceType
// ) => {
//   const items = filter.items.map((item) => {
//     if (item.resourceType === type) {
//       const targetState = item.filterState === FilterState.On ? FilterState.Off : FilterState.On
//       item.filterState = targetState
//     }
//     return item
//   })
//   return { items }
// }

// /**
//  * 获取选中的加电资源类型
//  * @param {string} filter 加电资源筛选器
//  * @returns {string} 加电资源类型
//  */
// export const getSelectedResourceTypes = (filter: PowerResourceFilter, showThirdResource = true) => {
//   const selectedTypes = filter.items.filter((item) => item.filterState === FilterState.On)
//   if (selectedTypes.length > 0) {
//     return selectedTypes.map((item) => item.resourceType).join(';')
//   } else if (!showThirdResource) {
//     return 'PowerSwap;NioChargeStationNpc;NioChargeStationDest' // 不包括三方点的筛选
//   }
// }

// /**
//  * 判断是否是加电资源ID
//  * @param {string} id 加电资源ID
//  * @returns {boolean} 是否是加电资源ID
//  */
// export const isPowerResourceId = (id?: string) => {
//   return id && (id.startsWith('PS') || id.startsWith('CS'))
// }

// /**
//  * 获取加电资源详情页头图
//  * @param {PowerResource} resource 加电资源ID
//  * @returns {string} 加电资源详情页头图
//  */
// export const getPowerResourceHeaderImg = (resource: PowerResource) => {
//   if (resource.type === 'PowerSwap') {
//     return 'https://cdn-app.nio.com/pe/ns/h5/ps.jpg'
//   }

//   if (resource.type === 'ChargeStation') {
//     switch (resource.chargeStationType) {
//       case 'NioChargeStationNpc':
//         return 'https://cdn-app.nio.com/pe/ns/h5/npc.jpg'
//       case 'NioChargeStationDest':
//         return 'https://cdn-app.nio.com/pe/ns/h5/dest.jpg'
//       case 'ThirdChargeStation':
//         return 'https://cdn-app.nio.com/pe/ns/h5/third.jpg'
//     }
//   }
// }
